import { Box, Icon, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ACDProgressBar from './ACDProgressBar'
import { useQuery, useQueryClient } from 'react-query'
import { getAppraisalEvals } from 'services/api/modules/performance/appraisal/appraisal'
import AdxButton from 'components/custom/AdxButton'

const ACDEvaluationList = ({ appraisalId, status_name, cycleName }) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [evaluations, setEvaluations] = useState([])
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('evaluationData')
    queryClient.resetQueries('evaluationData')
  }, [])

  const { isLoading, error, data } = useQuery(['evaluationData', appraisalId], async () => {
    const { data } = await getAppraisalEvals(appraisalId)
    setEvaluations(data ?? [])
  })

  const viewHandler = (item) => {
    navigate(`/app/appraisal-cycle/evaluation/${item.id}`, {
      state: {
        ...state,
        item,
        cycleName,
        status_name,
        id: state.id,
      },
    })
  }

  const manageHandler = () => {
    navigate(`/app/appraisal-cycle/${appraisalId}/manage-evaluation`, {
      state: {
        ...state,
        appraisalId,
        status_name,
        id: state.id,
      },
    })
  }

  return (
    <Box
      sx={{
        bgcolor: 'white.main',
        borderRadius: 2,
      }}
    >
      {evaluations?.map((i, index) => (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          py={2}
          px={3}
          sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
          key={index}
        >
          <Box display="flex" flexDirection="column">
            <Typography variant="h4" color="dark-text.main">
              {i.title}
            </Typography>
            <Box display="flex" gap={1} alignItems="center">
              <Typography variant="subtitle1" color="light-gray-text.main">
                {i.submission_total} participant(s)
              </Typography>
            </Box>
          </Box>
          {/* </Box> */}
          {status_name === 'Active' && i?.is_external === 0 ? (
            <Box display="flex" gap={5} alignItems="center">
              {i.submission_complete / i.submission_total !== 1 ? (
                <ACDProgressBar progress={(i.submission_complete / i.submission_total) * 100} />
              ) : (
                <Box
                  width="300px"
                  display="flex"
                  gap={1}
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <Icon sx={{ fontSize: 20, color: 'positive.main' }}>check_circle</Icon>
                  <Typography color="light-gray-text.main">Completed</Typography>
                </Box>
              )}
              <Box
                display="flex"
                alignItems="center"
                onClick={() => viewHandler(i)}
                sx={{ cursor: 'pointer' }}
              >
                <Typography
                  variant="subtitle1"
                  color="alternate.main"
                  sx={{ textDecoration: 'underline' }}
                >
                  View
                </Typography>
                <Icon sx={{ fontSize: 16, color: 'alternate.main' }}>chevron_right</Icon>
              </Box>
            </Box>
          ) : status_name === 'Completed' && i?.is_external === 0 ? (
            <Box
              display="flex"
              alignItems="center"
              onClick={() => viewHandler(i)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                variant="subtitle1"
                color="alternate.main"
                sx={{ textDecoration: 'underline' }}
              >
                View
              </Typography>
              <Icon sx={{ fontSize: 16, color: 'alternate.main' }}>chevron_right</Icon>
            </Box>
          ) : null}
        </Box>
      ))}

      {status_name === 'Scheduled' || status_name === 'Active' ? (
        <Box sx={{ p: 0.5 }}>
          <AdxButton
            variant={'ghost'}
            fullWidth
            startIcon={<EditIcon color="alternate" />}
            sx={{
              pl: 3,
              display: 'flex',
              justifyContent: 'flex-start',
              textDecoration: 'underline',
            }}
            onClick={() => manageHandler()}
          >
            Manage evaluation
          </AdxButton>
        </Box>
      ) : null}
    </Box>
  )
}

export default ACDEvaluationList
